var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"calendar-container",staticStyle:{"height":"100vh","display":"block"}},[_c('todos',{staticClass:"calendar-todos",staticStyle:{"width":"100%","height":"100%","display":"flex","justify-content":"center","align-items":"center"}}),_c('div',{staticStyle:{"background":"var(--favoriteBg)"}},[_c('myFooter')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }